import React, { useState, useEffect, useRef } from 'react';
import {
  Typography,
  Button,
  Chip,
  Box,
  CircularProgress,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Grid,
  useTheme,
} from '@material-ui/core';
import {
  ImportExport as ImportExportIcon,
  PictureAsPdf as PdfIcon,
  Today as TodayIcon
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { Modal, Tag } from 'antd';
import { DataGrid } from '@material-ui/data-grid';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { toast } from 'react-toastify';

// Services
import CliniqueService from '../../services/CliniqueService';
import ProduitVenduService from '../../services/ProduitVenduService';
import factureVente from '../../utils/factureVente';

// Variables d'environnement
// const PHARMACY_NAME = process.env.REACT_APP_PHARMACY_NAME || "PHARMACIE NDIOL FOUTA";
// const OWNER_NAME = process.env.REACT_APP_OWNER_NAME || "DR. AL Ousseynou KEITA";
// const ADDRESS_LINE1 = process.env.REACT_APP_ADDRESS_LINE1 || "Sor Diagne Route Nationale N 2";
// const ADDRESS_LINE2 = process.env.REACT_APP_ADDRESS_LINE2 || "X Médina Bois Saint-Louis - Tél: +221 33 961 08 80";
// const BUSINESS_INFO = process.env.REACT_APP_BUSINESS_INFO || "NINEA:007968079 - RC: SN-STL-2020-A-1225";
const PHARMACY_NAME = process.env.REACT_APP_PHARMACY_NAME || "PHARMACIE MAME DIARRA BOUSSO";
const OWNER_NAME = process.env.REACT_APP_OWNER_NAME || "DR. Ibrahima Khaliloulaye GNING";
const ADDRESS_LINE1 = process.env.REACT_APP_ADDRESS_LINE1 || "Sor Diagne Route Nationale N 2";
const ADDRESS_LINE2 = process.env.REACT_APP_ADDRESS_LINE2 || "Thies - Tél: +221 33 951 11 65";
const BUSINESS_INFO = process.env.REACT_APP_BUSINESS_INFO || "NINEA 010198837, RC:SN THS 2023 M 2570";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    padding: theme.spacing(2),
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    background: 'white',
    borderRadius: 8,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
  filterSelect: {
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    minWidth: 200,
  },
  dateFilterContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  dateButton: {
    background: '#f26522',
    color: 'white',
    fontWeight: 600,
    '&:hover': {
      background: '#f26522',
    },
  },
  todayButton: {
    background: 'linear-gradient(135deg, #388e3c 0%, #2e7d32 100%)',
    color: 'white',
    fontWeight: 600,
    '&:hover': {
      background: 'linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)',
    },
  },
  statChip: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    color: 'white',
    fontWeight: 600,
    fontSize: '0.9rem',
    padding: theme.spacing(1, 2),
  },
  pdfButton: {
    background: 'linear-gradient(135deg, #f44336 0%, #d32f2f 100%)',
    color: 'white',
    fontWeight: 600,
    '&:hover': {
      background: 'linear-gradient(135deg, #d32f2f 0%, #c62828 100%)',
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 400,
  },
  tableContainer: {
    backgroundColor: 'white',
    borderRadius: 8,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    overflow: 'hidden',
  },
  formField: {
    marginBottom: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      '&:hover fieldset': {
        borderColor: '#226D68',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#226D68',
      },
    },
  },
  dateInput: {
    '& .MuiOutlinedInput-input': {
      padding: theme.spacing(1),
    },
  },
}));

const ProduitVendu = () => {
  const classes = useStyles();
  const theme = useTheme();
  const componentRef = useRef();

  // États
  const [prodVendu, setProdVendus] = useState([]);
  const [allProdVendu, setAllProdVendus] = useState([]); 
  const [loading, setLoading] = useState(false);
  const [printBillModalVisibility, setPrintBillModalVisibilty] = useState(false);
  const [prodFacture, setProdFacture] = useState([]);
  const [selectedFacture, setSelectedFacture] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [updateProd, setUpdateProd] = useState({
    nomProd: "",
    prixProdVendu: "",
    qtVdu: "",
    nom: "",
    mode_payement: ""
  });

  // ✅ Nouveaux états pour le filtre par date
  const [dateFilter, setDateFilter] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // Colonnes pour le DataGrid de la facture
  const colCart = [
    { 
      field: 'codeIdProd', 
      headerName: 'ID', 
      width: 100, 
      hide: true 
    },
    {
      field: 'nomProd',
      headerName: 'PRODUIT',
      width: 250,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'qtVdu',
      headerName: 'QUANTITÉ',
      width: 120,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'prixProdVendu',
      headerName: 'PRIX UNITAIRE',
      width: 150,
      headerAlign: 'right',
      align: 'right',
      valueFormatter: (params) => {
        return `${Number(params.value || 0).toLocaleString('fr-FR')} Fcfa`;
      },
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'total',
      headerName: 'TOTAL',
      width: 150,
      headerAlign: 'right',
      align: 'right',
      valueFormatter: (params) => {
        return `${Number(params.value || 0).toLocaleString('fr-FR')} Fcfa`;
      },
      headerClassName: 'super-app-theme--header',
    }
  ];

  // Colonnes du tableau principal
  const columns = [
    {
      title: "PRODUIT", 
      field: "nomProd",
      cellStyle: { fontWeight: '500' },
    },
    { 
      title: "PRIX PRODUIT", 
      field: "prixProdVendu",
      render: (rowData) => `${Number(rowData.prixProdVendu || 0).toLocaleString('fr-FR')} Fcfa`,
    },
    { 
      title: "QUANTITÉ VENDUE", 
      field: "qtVdu",
      align: 'center',
    },
    { 
      title: "CLIENT", 
      field: "nom",
    },
    {
      title: "PAIEMENT", 
      field: "mode_payement",
      render: (rowData) => (
        <Tag 
          color={
            rowData.mode_payement === "WAVE" ? "#1AB3E5" : 
            rowData.mode_payement === "OM" ? "#f16e00" : "#009933"
          }
          style={{ 
            borderRadius: "4px",
            color: 'white',
            fontWeight: 'bold',
            border: 'none',
          }}
        >
          {rowData.mode_payement}
        </Tag>
      ),
      searchable: false, 
      export: false
    },
    { 
      title: "DONNÉ", 
      field: "donne",
      render: (rowData) => `${Number(rowData.donne || 0).toLocaleString('fr-FR')} Fcfa`,
    },
    { 
      title: "RENDU", 
      field: "rendu",
      render: (rowData) => `${Number(rowData.rendu || 0).toLocaleString('fr-FR')} Fcfa`,
    },
    { 
      title: "N° FACTURE", 
      field: "numFactSrt",
    },
    { 
      title: "DATE", 
      field: "dateInsert", 
      type: "date",
      render: (rowData) => moment(rowData.dateInsert).format('DD/MM/YYYY HH:mm'),
    },
    { 
      title: "VENDEUR", 
      field: "vendeur",
    },
  ];



  // ✅ Nouveau handler pour le filtre par date
  const handleDateFilter = async (filterType) => {
    setLoading(true);
    setDateFilter(filterType);
    
    try {
      let filteredData = [...allProdVendu];
      
      switch (filterType) {
        case 'today':
          // Filtrer les ventes d'aujourd'hui
          const today = moment().startOf('day');
          filteredData = allProdVendu.filter(produit => 
            moment(produit.dateInsert).isSame(today, 'day')
          );
          break;
          
        case 'custom':
          // Filtrer par plage de dates personnalisée
          if (startDate && endDate) {
            const start = moment(startDate).startOf('day');
            const end = moment(endDate).endOf('day');
            filteredData = allProdVendu.filter(produit => 
              moment(produit.dateInsert).isBetween(start, end, null, '[]')
            );
          }
          break;
          
        case 'all':
        default:
          // Afficher toutes les ventes
          filteredData = allProdVendu;
          break;
      }
      
      setProdVendus(filteredData);
    } catch (error) {
      console.error('Erreur filtre date:', error);
      toast.error('Erreur lors du filtrage par date');
    } finally {
      setLoading(false);
    }
  };

  // ✅ Handler pour réinitialiser les filtres de date
  const handleResetDateFilter = () => {
    setDateFilter('');
    setStartDate('');
    setEndDate('');
    setProdVendus(allProdVendu);
  };



  const handleGeneratePDF = async (rowData) => {
    const selectedRow = Array.isArray(rowData) ? rowData[0] : rowData;
    
    try {
      const response = await ProduitVenduService.generateFacture(selectedRow.numFactSrt);
      factureVente(response.data, {
        fileName: `facture_${selectedRow.numFactSrt}`,
        mode: 'download'
      });
      toast.success('Facture générée avec succès');
    } catch (error) {
      console.error('Erreur génération PDF:', error);
      toast.error('Erreur lors de la génération de la facture');
    }
  };

  // ✅ Nouvelle fonction pour générer le PDF de tous les produits vendus
  const handleGenerateAllPDF = async () => {
    try {
      // Utiliser les données actuelles affichées (filtrées ou non)
      if (prodVendu.length === 0) {
        toast.warning('Aucune donnée à exporter');
        return;
      }

      // Créer un tableau formaté pour la fonction factureVente
      const dataForPDF = prodVendu.map(produit => ({
        ...produit,
        total: (produit.prixProdVendu || 0) * (produit.qtVdu || 0)
      }));
  
      // Déterminer le nom du fichier et la période
      let fileName = `rapport_ventes_${moment().format('YYYY-MM-DD_HH-mm')}`;
      let period = 'Toutes les ventes';
  
      if (dateFilter === 'today') {
        fileName = `ventes_du_${moment().format('YYYY-MM-DD')}`;
        period = `Ventes du ${moment().format('DD/MM/YYYY')}`;
      } else if (dateFilter === 'custom' && startDate && endDate) {
        fileName = `ventes_${moment(startDate).format('YYYY-MM-DD')}_au_${moment(endDate).format('YYYY-MM-DD')}`;
        period = `Période du ${moment(startDate).format('DD/MM/YYYY')} au ${moment(endDate).format('DD/MM/YYYY')}`;
      }
  
      // Générer le PDF avec les options appropriées
      factureVente(dataForPDF, {
        fileName: fileName,
        mode: 'download',
        period: period
      });
      
      toast.success('Rapport PDF généré avec succès');
    } catch (error) {
      console.error('Erreur génération PDF complet:', error);
      toast.error('Erreur lors de la génération du rapport PDF');
    }
  };



  const handleEditClose = () => {
    setEditDialogOpen(false);
    setEditingProduct(null);
  };

  const handleUpdate = async () => {
    try {
      await CliniqueService.updateProdVendu(updateProd, editingProduct.idProdVdu);
      toast.success("Produit vendu modifié avec succès", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      refreshProdVendus();
      handleEditClose();
    } catch (error) {
      toast.error("Erreur lors de la modification", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  const handleUpdateChange = (e) => {
    setUpdateProd({ ...updateProd, [e.target.name]: e.target.value });
  };

  // Fonctions de rafraîchissement
  const refreshProdVendus = async () => {
    try {
      const response = await CliniqueService.getProdEtatVendu();
      setProdVendus(response.data);
      setAllProdVendus(response.data); 
      console.log("-------------------------------")
      console.log(response.data)
      console.log("-------------------------------")
    } catch (error) {
      console.error('Erreur rafraîchissement:', error);
    }
  };

  // Référence pour l'impression
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });



  // Effets
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await refreshProdVendus();
      } catch (error) {
        console.error('Erreur chargement:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Calcul des totaux pour la facture
  const calculateTotals = (products) => {
    if (!Array.isArray(products)) return { total: 0, quantity: 0 };
    
    return products.reduce((acc, product) => ({
      total: acc.total + (product.total || 0),
      quantity: acc.quantity + (product.qtVdu || 0),
    }), { total: 0, quantity: 0 });
  };

  const safeFactureData = Array.isArray(prodFacture) ? prodFacture : [];
  const safeFactureInfo = selectedFacture || {};
  const totals = calculateTotals(safeFactureData);

  return (
    <div className={classes.root}>
      {/* Barre d'actions avec filtres améliorés */}
      <Box className={classes.actionBar}>
        <Box className={classes.filterContainer}>
          {/* <Typography variant="h6" style={{ color: '#226D68', fontWeight: 600 }}>
            Filtres:
          </Typography> */}
          
          {/* Filtre par type de paiement
          <select 
            className={classes.filterSelect}
            onChange={handleFilters}
          >
            <option value="">Tous les types de paiement</option>
            {typesPaiement.map((type, index) => (
              <option key={index} value={type.designation}>
                {type.designation}
              </option>
            ))}
          </select> */}

          {/* Filtre par date */}
          <Box className={classes.dateFilterContainer}>
            <Button
              variant="contained"
              className={classes.todayButton}
              startIcon={<TodayIcon />}
              onClick={() => handleDateFilter('today')}
              disabled={dateFilter === 'today'}
            >
              Aujourd'hui
            </Button>
            
            <TextField
              label="Date début"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              className={classes.dateInput}
              style={{ minWidth: 150 }}
            />
            
            <TextField
              label="Date fin"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              className={classes.dateInput}
              style={{ minWidth: 150 }}
            />
            
            <Button
              variant="contained"
              className={classes.dateButton}
              onClick={() => handleDateFilter('custom')}
              disabled={!startDate || !endDate}
            >
              Appliquer
            </Button>
            
            {(dateFilter || startDate || endDate) && (
              <Button
                variant="outlined"
                onClick={handleResetDateFilter}
                style={{ 
                  color: '#226D68',
                  borderColor: '#226D68'
                }}
              >
                Réinitialiser
              </Button>
            )}
          </Box>
        </Box>
        
        <Box display="flex" alignItems="center" gap={2}>
          <Chip
            label={`${prodVendu.length} ventes`}
            className={classes.statChip}
          />
          
          {/* ✅ Bouton PDF pour tous les produits vendus */}
          <Button
            variant="contained"
            className={classes.pdfButton}
            startIcon={<PdfIcon />}
            onClick={handleGenerateAllPDF}
            disabled={prodVendu.length === 0}
          >
            PDF Complet
          </Button>
        </Box>
      </Box>

      {/* Indicateur de filtre actif */}
      {dateFilter === 'today' && (
        <Box mb={2} display="flex" alignItems="center" gap={1}>
          <Chip 
            label={`Ventes du ${moment().format('DD/MM/YYYY')}`}
            onDelete={handleResetDateFilter}
            color="primary"
            variant="outlined"
          />
        </Box>
      )}

      {dateFilter === 'custom' && startDate && endDate && (
        <Box mb={2} display="flex" alignItems="center" gap={1}>
          <Chip 
            label={`Période: ${moment(startDate).format('DD/MM/YYYY')} - ${moment(endDate).format('DD/MM/YYYY')}`}
            onDelete={handleResetDateFilter}
            color="primary"
            variant="outlined"
          />
        </Box>
      )}

      {/* Tableau qui prend tout l'espace */}
      <Paper className={classes.tableContainer}>
        {loading ? (
          <Box className={classes.loadingContainer}>
            <CircularProgress size={40} style={{ color: '#226D68' }} />
          </Box>
        ) : (
          <MaterialTable
            columns={columns}
            data={prodVendu}
            editable={{
              onRowUpdate: (newRow, oldRow) => new Promise((resolve) => {
                CliniqueService.updateProdVendu(newRow, oldRow.idProdVdu)
                  .then(() => {
                    toast.success("Produit vendu modifié avec succès", {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    refreshProdVendus();
                  })
                  .catch(console.error);
                setTimeout(resolve, 500);
              }),
              onRowDelete: (selectedRow) => new Promise((resolve) => {
                CliniqueService.deleteProdVendu(selectedRow.idProdVdu)
                  .then(() => {
                    toast.success("Produit vendu supprimé avec succès", {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    refreshProdVendus();
                  })
                  .catch(console.error);
                setTimeout(resolve, 1000);
              })
            }}
            actions={[
              {
                icon: () => <ImportExportIcon style={{ color: '#4CAF50' }} />,
                tooltip: "Télécharger la facture",
                onClick: (event, rowData) => handleGeneratePDF(rowData),
              }
            ]}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: "right",
              searchAutoFocus: true,
              searchFieldVariant: "outlined",
              filtering: true,
              paging: true,
              pageSizeOptions: [10, 20, 50, 100],
              pageSize: 20,
              paginationType: "stepped",
              showFirstLastPageButtons: true,
              exportButton: true,
              exportAllData: true,
              exportFileName: "Produits_vendus",
              actionsColumnIndex: -1,
              rowStyle: (data, index) => index % 2 === 0 ? { background: "#f8f9fa" } : null,
              headerStyle: {
                background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
                color: "#fff",
                fontSize: '14px',
                fontWeight: 600,
              },
              maxBodyHeight: 'calc(100vh - 200px)',
              minBodyHeight: '500px',
            }}
            title=""
            localization={{
              body: {
                emptyDataSourceMessage: "Aucun produit vendu à afficher",
                addTooltip: "Ajouter",
                deleteTooltip: "Supprimer",
                editTooltip: "Modifier",
              }
            }}
          />
        )}
      </Paper>

      {/* Modal de facture avec variables d'environnement */}
      <Modal
        open={printBillModalVisibility}
        onCancel={() => setPrintBillModalVisibilty(false)}
        title="Détails de la Vente"
        footer={null}
        width={800}
      >
        <div ref={componentRef}>
          <div style={{ margin: '14px', marginTop: '10px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <div>
                <h2><b>{PHARMACY_NAME}</b></h2>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '-8px' }}>
                <p style={{ marginTop: '-15px', fontSize: '16px' }}>{OWNER_NAME}</p>
                <p style={{ marginTop: '-16px', fontSize: '16px' }}>{ADDRESS_LINE1}</p>
                <p style={{ marginTop: '-10px', fontSize: '16px' }}>{ADDRESS_LINE2}</p>
                <p style={{ marginTop: '-7px', fontSize: '16px' }}>{BUSINESS_INFO}</p>
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', marginBottom: 16 }}>
              <div>
                <p><b>Vendeur:</b> {safeFactureInfo.vendeur}</p>
              </div>
              <div style={{ textAlign: 'right' }}>
                <p>Le: {moment(new Date()).format('DD-MM-YYYY HH:mm:ss')}</p>
                <p><b>N°:</b> {safeFactureInfo.numFactSrt}</p>
              </div>
            </div>

            <DataGrid
              rows={safeFactureData}
              columns={colCart}
              getRowId={(row) => row.codeIdProd}
              autoHeight
              hideFooter
              sx={{
                '& .super-app-theme--header': {
                  backgroundColor: '#226D68',
                  color: 'white',
                  fontWeight: 'bold',
                },
              }}
            />

            <div style={{ display: "flex", flexDirection: "column", marginTop: '10px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row' }}> 
                <div><b>Remise de:</b></div>   
                <div><b>{safeFactureInfo.remise || 0}%</b></div> 
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row' }}>  
                <div>Nombre d'articles :</div>  
                <div><b>{totals.quantity}</b></div> 
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', marginTop: '10px', fontWeight: 'bold' }}>  
                <div>Total :</div>  
                <div><b>{totals.total.toLocaleString('fr-FR')} Fcfa</b></div> 
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '20px', padding: '10px', borderTop: '1px solid #e0e0e0' }}>
              <div style={{ fontWeight: 'bold', color: '#226D68' }}>CETTE PHARMACIE EST LA VOTRE</div>
              <div style={{ fontWeight: 'bold', color: '#f26522' }}>MEILLEURE SANTÉ</div>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
            <Button 
              variant="contained" 
              color="primary" 
              startIcon={<ImportExportIcon />}
              onClick={handlePrint}
              style={{
                background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
                color: 'white',
                fontWeight: 600,
              }}
            >
              Imprimer
            </Button>
          </div>
        </div>
      </Modal>

      {/* Dialog de modification */}
      <Dialog
        open={editDialogOpen}
        onClose={handleEditClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="h5" style={{ color: '#226D68', fontWeight: 600 }}>
            Modifier le Produit Vendu
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Nom du produit"
                name="nomProd"
                value={updateProd.nomProd}
                onChange={handleUpdateChange}
                fullWidth
                variant="outlined"
                className={classes.formField}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Prix"
                name="prixProdVendu"
                value={updateProd.prixProdVendu}
                onChange={handleUpdateChange}
                fullWidth
                variant="outlined"
                className={classes.formField}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Quantité"
                name="qtVdu"
                value={updateProd.qtVdu}
                onChange={handleUpdateChange}
                fullWidth
                variant="outlined"
                className={classes.formField}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Client"
                name="nom"
                value={updateProd.nom}
                onChange={handleUpdateChange}
                fullWidth
                variant="outlined"
                className={classes.formField}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                onClick={handleUpdate}
                variant="contained"
                fullWidth
                style={{
                  background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
                  color: 'white',
                  fontWeight: 600,
                  padding: theme.spacing(1.5),
                }}
              >
                Mettre à jour
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ProduitVendu;